import type { CampaignAnalysisReportUsage } from '../helpers/analysis-report-usage';
import { CampaignAnalysisStartButton } from './campaign-analysis-start-button';

type Props = {
  disabledReason?: string;
  onStartAnalysis: () => void;
  reportUsage?: CampaignAnalysisReportUsage;
};

export function CampaignAnalysisEmptyState({
  disabledReason,
  onStartAnalysis,
  reportUsage,
}: Props) {
  return (
    <div className="bg-muted/30 flex min-h-65 flex-col items-center justify-center rounded-lg border p-8 text-center">
      <div className="flex max-w-xl flex-col items-center gap-4">
        <div className="flex flex-col items-center gap-2">
          <p className="text-foreground text-base font-semibold">
            Create your first campaign report
          </p>
          <p className="text-muted-foreground text-sm leading-6">
            Analyze tracked posts to find the patterns, top examples, and next creator actions that
            can improve this campaign.
          </p>
        </div>
        <CampaignAnalysisStartButton
          disabledReason={disabledReason}
          onStartAnalysis={onStartAnalysis}
          reportUsage={reportUsage}
          usagePlacement="below"
        />
      </div>
    </div>
  );
}
